import React from 'react'
import { ChatSettingsTop } from 'react-chat-engine';

const logoutSubmit = () => {
    localStorage.setItem('username', '')
    localStorage.setItem('password', '')

    window.location.reload();
}

const ChatTop = () => {
    return (
        <div>
            <ChatSettingsTop />
            <div>
                <form onSubmit={logoutSubmit}>   
                    <button className ="buttonLog" type="submit">
                        Logout
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ChatTop;